var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.0398 21.9292H14.1563C13.6914 21.9292 13.3146 22.306 13.3146 22.7709V34.5543C13.3146 35.0192 13.6914 35.396 14.1563 35.396H36.0398C36.5047 35.396 36.8815 35.0192 36.8815 34.5543V22.7709C36.8815 22.306 36.5047 21.9292 36.0398 21.9292Z",
    stroke: "currentColor",
    strokeWidth: 1.94,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0981 32.0298C26.9575 32.0298 28.4649 30.5225 28.4649 28.6631C28.4649 26.8037 26.9575 25.2964 25.0981 25.2964C23.2388 25.2964 21.7314 26.8037 21.7314 28.6631C21.7314 30.5225 23.2388 32.0298 25.0981 32.0298Z",
    stroke: "currentColor",
    strokeWidth: 1.94,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8037 22.4902C17.8037 24.6595 16.0451 26.4181 13.8759 26.4181",
    stroke: "currentColor",
    strokeWidth: 1.94,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3924 22.4902C32.3924 24.6595 34.1509 26.4181 36.3202 26.4181",
    stroke: "currentColor",
    strokeWidth: 1.94,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8037 34.8354C17.8037 32.6662 16.0451 30.9076 13.8759 30.9076",
    stroke: "currentColor",
    strokeWidth: 1.94,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3924 34.8354C32.3924 32.6662 34.1509 30.9076 36.3202 30.9076",
    stroke: "currentColor",
    strokeWidth: 1.94,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2426 15.751L19.7504 18.2588C20.0779 18.5863 20.609 18.5863 20.9366 18.2588L23.4444 15.751",
    stroke: "currentColor",
    strokeWidth: 1.94,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3431 12.3551V18.2616",
    stroke: "currentColor",
    strokeWidth: 1.94,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/Payment.f3fc7a00ff80aaf59b881c2f7836380f.svg";
export { ForwardRef as ReactComponent };